
export default function useStoryblokAdmin() {
  const isInStoryblokAdmin = (to: any = null): boolean => {
    const route = to ?? useRoute();
    if (route.query && route.query._storyblok && route.query._storyblok !== '') {
      return true;
    }
    return false;
  };

  const storyblokReleaseId = () => {
    const route = useRoute();
    return route.query?._storyblok_release ?? null;
  };

  return {
    isInStoryblokAdmin,
    storyblokReleaseId,
  };
}
